import { getRuntimeApiUrl } from "./runtimeApiUrl";

/**
 * The attendee's check-in QR code as an image URL: the same PNG their emails
 * and reminder text carry (`GET /spark/check-in/:token/qr`).
 */
export const checkInQrSrc = (checkInToken: string) =>
  `${getRuntimeApiUrl()}/spark/check-in/${checkInToken}/qr`;
